var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoginApp
    ? _c("div", { staticClass: "login-with-app" }, [
        _c(
          "div",
          {
            staticClass: "login-layout blur-login",
            style: {
              backgroundImage: "url(" + require("@/assets/images/bg.png") + ")"
            }
          },
          [
            _c(
              "div",
              { staticClass: "main-container", attrs: { id: "mainContainer" } },
              [
                _c("div", { staticClass: "main-content" }, [
                  _c("div", {}, [
                    _c("div", { staticClass: "col-sm-10 col-sm-offset-1" }, [
                      _c("div", { staticClass: "login-container" }, [
                        _c("div", { staticClass: "position-relative" }, [
                          _c("div", { attrs: { id: "login-box" } }, [
                            _c("div", [
                              _c("div", [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "header blue lighter bigger i-logo"
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.logo,
                                        alt: "logo",
                                        width: "200"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "header blue lighter bigger i-logo title-login"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    パスワード再発行\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.sucessStatus === true
                                  ? _c("div", [
                                      _c("div", { staticClass: "error" }, [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.message) +
                                            "\n                    "
                                        )
                                      ])
                                    ])
                                  : _c("div", [
                                      _vm.error === true
                                        ? _c("div", { staticClass: "error" }, [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(_vm.message) +
                                                "\n                    "
                                            )
                                          ])
                                        : _vm._e()
                                    ]),
                                _vm._v(" "),
                                _c("p"),
                                _vm._v(" "),
                                _c(
                                  "form",
                                  {
                                    attrs: { novalidate: "" },
                                    on: {
                                      submit: function($event) {
                                        $event.preventDefault()
                                        _vm.validateBeforeSubmit($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("fieldset", [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "form-item width-80" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.credentials.ownerId,
                                                  expression:
                                                    "credentials.ownerId"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                required: "",
                                                autocomplete: "off",
                                                name: "ownerId",
                                                id: "ownerId"
                                              },
                                              domProps: {
                                                value: _vm.credentials.ownerId
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.credentials,
                                                    "ownerId",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              { attrs: { for: "password" } },
                                              [_vm._v("事業者ID")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "ownerId"
                                                    ),
                                                    expression:
                                                      "errors.has('ownerId')"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first("ownerId")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-item width-80" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.credentials.userId,
                                                  expression:
                                                    "credentials.userId"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                required: "",
                                                autocomplete: "off",
                                                name: "userId",
                                                id: "userId"
                                              },
                                              domProps: {
                                                value: _vm.credentials.userId
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.credentials,
                                                    "userId",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.isNTT
                                              ? _c(
                                                  "label",
                                                  {
                                                    attrs: { for: "password" }
                                                  },
                                                  [_vm._v("会員ID")]
                                                )
                                              : _c(
                                                  "label",
                                                  {
                                                    attrs: { for: "password" }
                                                  },
                                                  [_vm._v("ユーザーID")]
                                                ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "userId"
                                                    ),
                                                    expression:
                                                      "errors.has('userId')"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first("userId")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "clearfix login-button"
                                          },
                                          [
                                            _c(
                                              "button",
                                              { attrs: { type: "submit" } },
                                              [
                                                _c("span", [
                                                  _c("img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src:
                                                        "" +
                                                        require("@/assets/images/icon/send.png")
                                                    }
                                                  })
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("送信する")])
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "forgot-password-text" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "forgot-password-link",
                                      attrs: { tag: "a", to: { name: "login" } }
                                    },
                                    [
                                      _c("span", [
                                        _c("img", {
                                          staticClass: "btn-icon-link",
                                          attrs: {
                                            src:
                                              "" +
                                              require("@/assets/images/icon/arrow-w.png")
                                          }
                                        })
                                      ]),
                                      _vm._v(
                                        "\n                    ログインページに戻る\n                  "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ]
        )
      ])
    : _c("div", { staticClass: "login-layout blur-login" }, [
        _c("div", { staticClass: "main-container" }, [
          _c("div", { staticClass: "main-content" }, [
            _vm.loading
              ? _c("div", { attrs: { id: "loading" } }, [
                  _c("div", { staticClass: "loadingMsg" })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-10 col-sm-offset-1" }, [
                _c("div", { staticClass: "login-container" }, [
                  _c(
                    "div",
                    {
                      class: {
                        "position-relative round_black": _vm.isNTT,
                        "position-relative": !_vm.isNTT
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "forgot-box visible widget-box no-border",
                          attrs: { id: "forgot-box" }
                        },
                        [
                          _vm.sucessStatus === true
                            ? [
                                _c("div", { staticClass: "widget-body" }, [
                                  _c("div", { staticClass: "widget-main" }, [
                                    _vm._m(0),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "space-6" }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "alert alert-success" },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.message) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "toolbar center" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "back-to-login-link",
                                          attrs: {
                                            tag: "a",
                                            to: { name: "login" }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "ace-icon fa fa-arrow-right"
                                          }),
                                          _vm._v(
                                            "\n                      ログインページに戻る\n                    "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            : [
                                _c("div", { staticClass: "widget-body" }, [
                                  _c("div", { staticClass: "widget-main" }, [
                                    _vm._m(1),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "space-6" }),
                                    _vm._v(" "),
                                    _vm.error === true
                                      ? _c(
                                          "div",
                                          { staticClass: "alert alert-danger" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(_vm.message) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "form",
                                      {
                                        on: {
                                          submit: function($event) {
                                            $event.preventDefault()
                                            _vm.validateBeforeSubmit($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("fieldset", [
                                          _c(
                                            "label",
                                            { staticClass: "block clearfix" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.errors.has(
                                                        "ownerId"
                                                      ),
                                                      expression:
                                                        "errors.has('ownerId')"
                                                    }
                                                  ],
                                                  staticClass: "error"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "ownerId"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "block input-icon input-icon-right"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      },
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.credentials
                                                            .ownerId,
                                                        expression:
                                                          "credentials.ownerId"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      error: _vm.errors.has(
                                                        "ownerId"
                                                      )
                                                    },
                                                    attrs: {
                                                      name: "ownerId",
                                                      type: "text",
                                                      placeholder: "事業者ID"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.credentials.ownerId
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.credentials,
                                                          "ownerId",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "ace-icon fa fa-user"
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { staticClass: "block clearfix" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.errors.has(
                                                        "userId"
                                                      ),
                                                      expression:
                                                        "errors.has('userId')"
                                                    }
                                                  ],
                                                  staticClass: "error"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.errors.first("userId")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "block input-icon input-icon-right"
                                                },
                                                [
                                                  _vm.isNTT
                                                    ? _c("input", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: "required",
                                                            expression:
                                                              "'required'"
                                                          },
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.credentials
                                                                .userId,
                                                            expression:
                                                              "credentials.userId"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          error: _vm.errors.has(
                                                            "userId"
                                                          )
                                                        },
                                                        attrs: {
                                                          name: "userId",
                                                          type: "text",
                                                          placeholder: "会員ID"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.credentials
                                                              .userId
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              _vm.credentials,
                                                              "userId",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _c("input", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: "required",
                                                            expression:
                                                              "'required'"
                                                          },
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.credentials
                                                                .userId,
                                                            expression:
                                                              "credentials.userId"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          error: _vm.errors.has(
                                                            "userId"
                                                          )
                                                        },
                                                        attrs: {
                                                          name: "userId",
                                                          type: "text",
                                                          placeholder:
                                                            "ユーザーID"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.credentials
                                                              .userId
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              _vm.credentials,
                                                              "userId",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "ace-icon fa fa-user"
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._m(2)
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "toolbar center" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "back-to-login-link",
                                          attrs: {
                                            tag: "a",
                                            to: { name: "login" }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "ace-icon fa fa-arrow-right"
                                          }),
                                          _vm._v(
                                            "\n                      ログインページに戻る\n                    "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                        ],
                        2
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "header red lighter bigger" }, [
      _c("i", { staticClass: "ace-icon fa fa-key" }),
      _vm._v("\n                      パスワード再発行\n                    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "header red lighter bigger" }, [
      _c("i", { staticClass: "ace-icon fa fa-key" }),
      _vm._v("\n                      パスワード再発行\n                    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "clearfix" }, [
      _c(
        "button",
        {
          staticClass: "width-100 pull-right btn btn-sm btn-danger",
          attrs: { type: "submit" }
        },
        [_c("span", { staticClass: "bigger-110" }, [_vm._v("送信")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ba7e77e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ba7e77e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/ForgotPassword.vue
// module id = null
// module chunks = 